import {GitHubRepository} from '@package/shared'
import type {z} from 'zod'

export const FormValues = GitHubRepository.pick({
  projectId: true,
})
export type FormValues = z.infer<typeof FormValues>
